import axios from '@/api'

export default {
  namespaced : true,
  state : {
    customers : {
      customers : [],
      pagination : {
        page: 1,
        limit: 10,
        total: 0,
        pages: 0,
        prev: null,
        next: null
      }
    },
    currentPage : 1,
  },
  getters : {

  },
  mutations : {
    SET_CUSTOMERS(state, payload){
      state.customers = payload;
    },
    SET_CURRENT_PAGE(state, payload){
      state.currentPage = payload;
    }
  },
  actions: {
    fetchCustomers({ commit },payload){
      return new Promise((resolve, reject) => {
        if(payload.page){
          commit('SET_CURRENT_PAGE', payload.page)
        }
        axios.get(`/admin/customers/search/${payload.search ? payload.search:''}`,{params:  payload})
          .then((response) => {
            commit('SET_CUSTOMERS', response.data);
            resolve(response.data)
          })
          .catch((error) => { reject(error) })
      })
    },
    fetchCustomersTrips({ commit },payload){
      return new Promise((resolve, reject) => {
        if(payload.page){
          commit('SET_CURRENT_PAGE', payload.page)
        }
        axios.get(`/admin/customers/${payload.id}/trips/`,{params:  payload})
          .then((response) => {   
            resolve(response.data)
          })
          .catch((error) => { reject(error) })
      })
    },
    fetchCustomerDetails({ commit },payload){
      return new Promise((resolve, reject) => {
        if(payload.page){
          commit('SET_CURRENT_PAGE', payload.page)
        }
        axios.get(`/admin/customers/${payload.id}`,{params:  payload})
          .then((response) => {   
            resolve(response.data)
          })
          .catch((error) => { reject(error) })
      })
    },
    
    fetchCustomerRoutes({ commit },payload){
      return new Promise((resolve, reject) => { 
        axios.get(`/admin/customers/${payload.id}/routes/`,{params:  payload})
          .then((response) => {   
            resolve(response.data)
          })
          .catch((error) => { reject(error) })
      })
    },
    downloadTripReport({commit}, payload){
      return new Promise((resolve, reject) =>{
        let url = `/admin/customers/${payload.id}/trips?format=csv&export=true`;
        axios.get(url ,{params:  payload})
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
  }
}
